<template>
	<transition name="slide-fade" mode="out-in">
    	<div class="contain">
		    <div>
		        <img class="width-375" src="../../../images/other/outline.png">
		    </div>
		    <div class="text-c padding-t-16 padding-b-16">
		        <div class="color-999">超级会员{{memberInfo.levelCode}}</div>
		        <div class="size-16">实体版年度纪念礼盒</div>
		    </div>
		    <div class="cut-line-8"></div>
		    <div class="padding-lr-24">
		        <div class="color-999 flex-row1 height-56 size-16">规则</div>
		        <div >
		            <div class="position-a">1、</div>
		            <div class="padding-l-16">年度礼盒为广材网VIP企业特权，按企业等级获得。</div>
		        </div>
		        <div>
		            <div class="position-a">2、</div>
		            <div class="padding-l-16">仅限V5等级会员享有，在每年特殊时间领取。</div>
		        </div>
		        <div >
		            <div class="position-a">3、</div>
		            <div class="padding-l-16">实体版年度纪念礼盒包含实体纪念卡、定制礼品等，每人仅限1份。</div>
		        </div>
		    </div>
		    <div class="m-bottom-fixed">
		        <div class="btn-solid1 opacity-3">暂未开启</div>
		    </div>
    	</div>
	</transition>
</template>

<style lang="less" scoped>
@import "../../../style/variable.less";
</style>

<script>
module.exports = require("./index.js")
</script>